module.exports = __webpack_public_path__ + "img/9.16ffdb7e.png";